var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTasks(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 626,
    height: 205.5,
    viewBox: "0 0 626 205.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(-340 -513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "img-tasks",
    transform: "translate(-24 6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(3 -33)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task_01",
    "data-name": "Task 01",
    transform: "translate(64 243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box",
    transform: "translate(340 297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_118",
    "data-name": "Rectangle 118",
    fill: "#fff",
    stroke: "#e9eaf5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 583,
    height: 90,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 582,
    height: 89,
    rx: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OKR",
    transform: "translate(732 350)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "New_Product_Launch",
    "data-name": "New Product Launch",
    transform: "translate(0 15)",
    fontSize: 14,
    fontFamily: "OpenSans-Regular, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Product Launch"))), /*#__PURE__*/React.createElement("g", {
    id: "Assignee",
    transform: "translate(481 349)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Jason_Response",
    "data-name": "Jason Response",
    transform: "translate(1 15)",
    fontSize: 14,
    fontFamily: "OpenSans-Regular, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Jason Response"))), /*#__PURE__*/React.createElement("g", {
    id: "Task",
    transform: "translate(479 318)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Ensure_that_the_website_can_operate_well_across_all_devices",
    "data-name": "Ensure that the website can operate well across all devices",
    transform: "translate(0 15)",
    fill: "#3d3d3d",
    fontSize: 14,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ensure that the website can operate well across all devices"))), /*#__PURE__*/React.createElement("g", {
    id: "Due_Date",
    "data-name": "Due Date",
    transform: "translate(-60.49 -229)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Due_Date-2",
    "data-name": "Due Date",
    transform: "translate(452.5 583.5)",
    fill: "#3d3d3d",
    fontSize: 10,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Due Date")), /*#__PURE__*/React.createElement("text", {
    id: "_28_11_2022",
    "data-name": "28/11/2022",
    transform: "translate(452.5 598.98)",
    fill: "#3d3d3d",
    fontSize: 10,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28/11/2022"))), /*#__PURE__*/React.createElement("g", {
    id: "Tag",
    transform: "translate(390 320.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-down",
    transform: "translate(-407.187 -237.826)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M471.073,241.123l4.594,4.592,4.592-4.592,1.408,1.406-6,6-6-6Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tag-2",
    "data-name": "Tag",
    transform: "translate(-996 -391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 54,
    height: 14,
    rx: 2,
    transform: "translate(996 391)",
    fill: "#6ddeb3"
  }), /*#__PURE__*/React.createElement("text", {
    id: "NORMAL",
    transform: "translate(1005 401)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NORMAL")))), /*#__PURE__*/React.createElement("g", {
    id: "Checkbox",
    transform: "translate(360 317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(-5405.283 -1270.469)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M5425.281,1280.49c0,2.3,0,4.608,0,6.912a3.031,3.031,0,0,1-.465,1.748,2.92,2.92,0,0,1-2.573,1.333c-1.543.006-3.087,0-4.631,0h-9.227a3.033,3.033,0,0,1-2.207-.815,2.784,2.784,0,0,1-.874-1.795c-.016-.169-.021-.34-.021-.51q0-6.9,0-13.789a3.06,3.06,0,0,1,.523-1.865,2.826,2.826,0,0,1,2.209-1.229c.113-.007.227-.01.34-.01q6.929,0,13.857,0a3.015,3.015,0,0,1,1.886.565,2.793,2.793,0,0,1,1.166,2.1c.013.181.015.363.015.544Q5425.282,1277.085,5425.281,1280.49Zm-9.988-8.6h-4.017c-1.066,0-2.133-.007-3.2,0a1.328,1.328,0,0,0-1.362,1.251,4.288,4.288,0,0,0-.027.475q0,6.86,0,13.719a4.388,4.388,0,0,0,.035.543,1.323,1.323,0,0,0,1,1.121,2.5,2.5,0,0,0,.573.061q7,.005,13.991,0c.08,0,.159,0,.238-.006a1.362,1.362,0,0,0,1.332-1.3,4.04,4.04,0,0,0,.024-.441q0-6.859,0-13.719a4.323,4.323,0,0,0-.032-.509,1.328,1.328,0,0,0-1.067-1.176,2.8,2.8,0,0,0-.542-.031Q5418.766,1271.888,5415.293,1271.889Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M5423.038,1294.137c.1-.1.2-.183.283-.269q2.37-2.35,4.74-4.7a2.32,2.32,0,0,1,.362-.307.629.629,0,0,1,.83.112.617.617,0,0,1,.078.837,2.021,2.021,0,0,1-.247.281q-2.695,2.7-5.393,5.394l-.072.072a.7.7,0,0,1-1.171-.01q-1.341-1.331-2.672-2.673c-.352-.355-.388-.63-.149-.964a.645.645,0,0,1,.925-.171,2.108,2.108,0,0,1,.282.245q.961.941,1.919,1.885C5422.841,1293.956,5422.933,1294.039,5423.038,1294.137Z",
    transform: "translate(-9.185 -11.834)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(3 82)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Task_01-2",
    "data-name": "Task 01",
    transform: "translate(64 243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Box-2",
    "data-name": "Box",
    transform: "translate(340 297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_118-2",
    "data-name": "Rectangle 118",
    fill: "#fff",
    stroke: "#e9eaf5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 583,
    height: 90,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 582,
    height: 89,
    rx: 3.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OKR-2",
    "data-name": "OKR",
    transform: "translate(732 350)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "New_Product_Launch-2",
    "data-name": "New Product Launch",
    transform: "translate(0 15)",
    fontSize: 14,
    fontFamily: "OpenSans-Regular, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "New Product Launch"))), /*#__PURE__*/React.createElement("g", {
    id: "Assignee-2",
    "data-name": "Assignee",
    transform: "translate(481 349)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Jason_Response-2",
    "data-name": "Jason Response",
    transform: "translate(1 15)",
    fontSize: 14,
    fontFamily: "OpenSans-Regular, Open Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Jason Response"))), /*#__PURE__*/React.createElement("g", {
    id: "Task-2",
    "data-name": "Task",
    transform: "translate(479 318)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Prepare_sales_decks_and_brochures",
    "data-name": "Prepare sales decks and brochures",
    transform: "translate(0 15)",
    fill: "#3d3d3d",
    fontSize: 14,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Prepare sales decks and brochures"))), /*#__PURE__*/React.createElement("g", {
    id: "Due_Date-3",
    "data-name": "Due Date",
    transform: "translate(-60.49 -229)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Due_Date-4",
    "data-name": "Due Date",
    transform: "translate(452.5 583.5)",
    fill: "#3d3d3d",
    fontSize: 10,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Due Date")), /*#__PURE__*/React.createElement("text", {
    id: "_28_11_2022-2",
    "data-name": "28/11/2022",
    transform: "translate(452.5 598.98)",
    fill: "#3d3d3d",
    fontSize: 10,
    fontFamily: "OpenSans-SemiBold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "28/11/2022"))), /*#__PURE__*/React.createElement("g", {
    id: "Tag-3",
    "data-name": "Tag",
    transform: "translate(390 320.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevron-down-2",
    "data-name": "chevron-down",
    transform: "translate(-407.187 -237.826)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64-2",
    "data-name": "Path 64",
    d: "M471.073,241.123l4.594,4.592,4.592-4.592,1.408,1.406-6,6-6-6Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Tag-4",
    "data-name": "Tag",
    transform: "translate(-996 -391)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92-2",
    "data-name": "Rectangle 92",
    width: 54,
    height: 14,
    rx: 2,
    transform: "translate(996 391)",
    fill: "#6ddeb3"
  }), /*#__PURE__*/React.createElement("text", {
    id: "NORMAL-2",
    "data-name": "NORMAL",
    transform: "translate(1005 401)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "NORMAL")))), /*#__PURE__*/React.createElement("g", {
    id: "Checkbox-2",
    "data-name": "Checkbox",
    transform: "translate(360 317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42-2",
    "data-name": "Group 42",
    transform: "translate(-5405.283 -1270.469)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115-2",
    "data-name": "Path 115",
    d: "M5425.281,1280.49c0,2.3,0,4.608,0,6.912a3.031,3.031,0,0,1-.465,1.748,2.92,2.92,0,0,1-2.573,1.333c-1.543.006-3.087,0-4.631,0h-9.227a3.033,3.033,0,0,1-2.207-.815,2.784,2.784,0,0,1-.874-1.795c-.016-.169-.021-.34-.021-.51q0-6.9,0-13.789a3.06,3.06,0,0,1,.523-1.865,2.826,2.826,0,0,1,2.209-1.229c.113-.007.227-.01.34-.01q6.929,0,13.857,0a3.015,3.015,0,0,1,1.886.565,2.793,2.793,0,0,1,1.166,2.1c.013.181.015.363.015.544Q5425.282,1277.085,5425.281,1280.49Zm-9.988-8.6h-4.017c-1.066,0-2.133-.007-3.2,0a1.328,1.328,0,0,0-1.362,1.251,4.288,4.288,0,0,0-.027.475q0,6.86,0,13.719a4.388,4.388,0,0,0,.035.543,1.323,1.323,0,0,0,1,1.121,2.5,2.5,0,0,0,.573.061q7,.005,13.991,0c.08,0,.159,0,.238-.006a1.362,1.362,0,0,0,1.332-1.3,4.04,4.04,0,0,0,.024-.441q0-6.859,0-13.719a4.323,4.323,0,0,0-.032-.509,1.328,1.328,0,0,0-1.067-1.176,2.8,2.8,0,0,0-.542-.031Q5418.766,1271.888,5415.293,1271.889Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116-2",
    "data-name": "Path 116",
    d: "M5423.038,1294.137c.1-.1.2-.183.283-.269q2.37-2.35,4.74-4.7a2.32,2.32,0,0,1,.362-.307.629.629,0,0,1,.83.112.617.617,0,0,1,.078.837,2.021,2.021,0,0,1-.247.281q-2.695,2.7-5.393,5.394l-.072.072a.7.7,0,0,1-1.171-.01q-1.341-1.331-2.672-2.673c-.352-.355-.388-.63-.149-.964a.645.645,0,0,1,.925-.171,2.108,2.108,0,0,1,.282.245q.961.941,1.919,1.885C5422.841,1293.956,5422.933,1294.039,5423.038,1294.137Z",
    transform: "translate(-9.185 -11.834)"
  })))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y2: 205,
    transform: "translate(340.5 513.5)",
    fill: "none",
    stroke: "#e9eaf5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 31,
    transform: "translate(340.5 559.5)",
    fill: "none",
    stroke: "#e9eaf5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 31,
    transform: "translate(340.5 674.5)",
    fill: "none",
    stroke: "#e9eaf5",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTasks);
export default __webpack_public_path__ + "static/media/no_tasks.8b73db270a9a083f7ec3c84ae42b1c4d.svg";
export { ForwardRef as ReactComponent };